export const getTokenFromStorage = () => {
  return localStorage.getItem("token");
};

export const removeTokenToStorage = () => {
  localStorage.removeItem("token");
};

export const setTokenToStorage = (token: string) => {
  localStorage.setItem("token", token);
};
